import styled from "styled-components";

export const Disabled = styled("div")`
  pointer-events: none;
  opacity: 0.4;
`;
